/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyExternalOrderItem } from 'app/shared/model/pharmacy-external-order-item.model';
import { IPharmacyExternalOrderShipment } from 'app/shared/model/pharmacy-external-order-shipment.model';
import { PharmacyProductType } from 'app/shared/model/enumerations/pharmacy-product-type.model';

export interface IPharmacyExternalOrderShipmentItem {
  id?: string;
  shippedQty?: number | null;
  receivedQty?: number | null;
  packs?: number | null;
  productType?: keyof typeof PharmacyProductType | null;
  productId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  purchaseBillItemId?: string | null;
  freeQty?: number | null;
  orderItem?: IPharmacyExternalOrderItem | null;
  shipment?: IPharmacyExternalOrderShipment | null;
}

export const defaultValue: Readonly<IPharmacyExternalOrderShipmentItem> = {
  active: false,
};
